const templateUrl = require('./header.html');

module.exports = angular.module('msi.modals.header', []).name;

angular.module(module.exports)
  .component('ogModalHeader', {
    transclude: true,
    templateUrl: templateUrl
  });
